/**
 * Web 三栏布局可显示页面配置
 * 
 * 📝 添加新页面到第三栏只需 3 步：
 * 1. import 你的页面组件
 * 2. 在下面的数组中添加配置
 * 3. 完成！不需要修改其他任何代码
 * 
 * 配置说明：
 * - name: 页面名称（必须与路由名称完全一致）
 * - component: 页面组件
 * - hideBackButton: Web 环境下是否隐藏返回按钮（建议 true）
 * - tabType: 属于哪个 tab（Contact/Chat/Mine），用于自动切换
 */

import { ContactInfo } from '../screen/Contact/ContactInfo';
import { ChatList } from '../screen/Chat/ChatList';
import { FriendApplyList } from '../screen/Contact/FriendApplyList';
import { GroupList } from '../screen/Contact/GroupList';
import { ContactsLabelScreen } from '../screen/label/ContactsLabelScreen';
import { MassSendingAssistant } from '../screen/Chat/MassSendingAssistant';
import { AccountSecuritySetting } from '../screen/setting/account_security_setting';
import { PrivacySetting } from '../screen/setting/privacy_setting';
import { OtherSetting } from '../screen/setting/other_setting';
import { Announcement } from '../screen/Announcement';
import { PersonalDetails } from '../screen/Mine/PersonalDetails';
import { WebNavigableScreen } from '../utils/WebNavigationHelper';

/**
 * 页面配置列表
 * 
 * ⚠️ 注意：
 * - name 必须与路由名称完全一致（区分大小写）
 * - component 必须是正确导入的组件
 * - 添加新配置后无需重启，webpack 会自动热更新
 */
export const webNavigableScreens: WebNavigableScreen[] = [
    // ========== 联系人相关页面 ==========
    {
        name: 'ContactInfo',
        component: ContactInfo,
        hideBackButton: true,
        tabType: 'Contact'
    },
    {
        name: 'FriendApplyList',
        component: FriendApplyList,
        hideBackButton: true,
        tabType: 'Contact'
    },
    {
        name: 'GroupList',
        component: GroupList,
        hideBackButton: true,
        tabType: 'Contact'
    },
    {
        name: 'ContactsLabelScreen',
        component: ContactsLabelScreen,
        hideBackButton: true,
        tabType: 'Contact'
    },
    {
        name: 'MassSendingAssistant',
        component: MassSendingAssistant,
        hideBackButton: true,
        tabType: 'Contact'  // 群发助手在联系人 tab 下点击，应该留在联系人 tab
    },

    // ========== 聊天相关页面 ==========
    {
        name: 'ChatList',
        component: ChatList,
        hideBackButton: true,
        tabType: 'Chat'
    },

    // ========== 我的相关页面 ==========
    {
        name: 'PersonalDetails',
        component: PersonalDetails,
        hideBackButton: true,
        tabType: 'Mine'
    },
    {
        name: 'AccountSecuritySetting',
        component: AccountSecuritySetting,
        hideBackButton: true,
        tabType: 'Mine'
    },
    {
        name: 'PrivacySetting',
        component: PrivacySetting,
        hideBackButton: true,
        tabType: 'Mine'
    },
    {
        name: 'OtherSetting',
        component: OtherSetting,
        hideBackButton: true,
        tabType: 'Mine'
    },
    {
        name: 'Announcement',
        component: Announcement,
        hideBackButton: true,
        tabType: 'Mine'
    },
    
    // ========== 添加新页面示例 ==========
    // 1. 先 import 组件：
    //    import { MyNewScreen } from '../screen/MyNewScreen';
    // 
    // 2. 然后添加配置：
    //    {
    //        name: 'MyNewScreen',           // 页面名称（与路由名称一致）
    //        component: MyNewScreen,         // 页面组件
    //        hideBackButton: true,          // Web 环境下隐藏返回按钮
    //        tabType: 'Contact'             // 属于哪个 tab
    //    },
    // 
    // 3. 完成！不需要修改其他代码
];
